import React, { Component } from 'react';
import PropTypes from 'prop-types';

import clearIcon from '../../../images/clear-field-icon.png';

const uniq = arr => {
  const out = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (out.indexOf(arr[i]) === -1) {
      out.push(arr[i]);
    }
  }
  return out;
};

/* istanbul ignore next */
const getClipboardData = e => {
  if (window.clipboardData) {
    return window.clipboardData.getData('Text');
  }
  if (e.clipboardData) {
    return e.clipboardData.getData('text/plain');
  }
  return '';
};

const defaultRenderTag = props => {
  const {
    tag,
    key,
    disabled,
    onRemove,
    classNameRemove,
    getTagDisplayValue,
    objectsAdded,
    className,
    handleEditTag,
    selectedEditIndex,
    inputComponent,
    errorPosition,
    errorMessage,
  } = props;

  const isParentTag = objectsAdded[key].recType === 'H';
  const isFolderTag = objectsAdded[key].recordTag === 'C' || 'S' || 'T';
  const isQuestionTag = objectsAdded[key].recordTag === 'Q';
  const isAnswerTag = objectsAdded[key].recordTag === 'A';

  const parentClassName = isParentTag ? 'parent-tag' : '';
  const folderClassName = isFolderTag ? 'folder-tag' : '';
  const questionClassName = isQuestionTag ? 'question-tag' : '';
  const answerClassName = isAnswerTag ? 'answer-tag' : '';

  const errorClassName = key === errorPosition ? 'error-tag' : '';
  const errorTitle = key === errorPosition ? errorMessage : '';
  const isOperatorTag = tag === 'AND' ||
  tag === 'OR' ||
  tag === 'NOT' ||
  tag === 'XOR' ||
  tag === 'AS' ||
  tag === '(' ||
  tag === ')';

  const tagClassNames =
    tag === 'AND' ||
    tag === 'OR' ||
    tag === 'NOT' ||
    tag === 'XOR' ||
    tag === 'AS' ||
    tag === '(' ||
    tag === ')'
      ? ` ${parentClassName} ${className} tag-operator ${errorClassName}`
      : `${parentClassName} ${className} ${folderClassName} ${questionClassName} ${answerClassName} ${errorClassName}`;

  const tagElement = (
    <span
      title={errorTitle || (!isOperatorTag ? `${getTagDisplayValue(tag)}
${objectsAdded[key].breadcrumbs}` : `${getTagDisplayValue(tag)}`)}
      className={tagClassNames}
      style={{ paddingTop: isOperatorTag && '1rem' }}
    >
      <span>{getTagDisplayValue(tag)}</span>
      {!disabled && (
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      )}
      {(objectsAdded[key].breadcrumbs) ? <p className="react-tagsinput-breadcrumb">{objectsAdded[key].breadcrumbs}</p> : ''}
    </span>
  );

  const editElement = (
    <span className="editPlaceholder" onClick={() => handleEditTag(key)} />
  );

  const optionA = (
    <div key={key} className="tagAlignment">
      {inputComponent}
      {tagElement}
    </div>
  );
  const optionB = (
    <div key={key} className="tagAlignment">
      {editElement}
      {tagElement}
    </div>
  );

  return key === selectedEditIndex ? optionA : optionB;
};

defaultRenderTag.propTypes = {
  key: PropTypes.number,
  tag: PropTypes.string,
  onRemove: PropTypes.func,
  classNameRemove: PropTypes.string,
  className: PropTypes.string,
  getTagDisplayValue: PropTypes.func,
  handleEditTag: PropTypes.func,
  disabled: PropTypes.bool,
  objectsAdded: PropTypes.arrayOf,
  selectedEditIndex: PropTypes.number,
  inputComponent: PropTypes.element,
};

const defaultRenderInput = ({ ...props }) => {
  const { onChange, value, ...other } = props;
  return <input type="text" onChange={onChange} value={value} {...other} />;
};

defaultRenderInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const defaultRenderLayout = (
  tagComponents,
  inputComponent,
  inputReplacementComponent,
  clearAllButton,
  selectedEditIndex,
) => (
  <span>
    {tagComponents}
    {selectedEditIndex < 0 ? inputComponent : inputReplacementComponent}
    {clearAllButton}
  </span>
);

const defaultPasteSplit = data => data.split(' ').map(d => d.trim());

const defaultInputProps = {
  className: 'react-tagsinput-input',
  placeholder: 'Add a tag',
};

class TagsInput extends Component {
  static propTypes = {
    addKeys: PropTypes.arrayOf(PropTypes.number),
    addOnBlur: PropTypes.bool,
    addOnPaste: PropTypes.bool,
    // currentValue: PropTypes.string,
    inputValue: PropTypes.string,
    inputProps: PropTypes.shape({}),
    onChange: PropTypes.func.isRequired,
    onChangeInput: PropTypes.func,
    removeKeys: PropTypes.arrayOf(PropTypes.number),
    renderInput: PropTypes.func,
    renderTag: PropTypes.func,
    renderLayout: PropTypes.func,
    handleAdd: PropTypes.func,
    pasteSplit: PropTypes.func,
    tagProps: PropTypes.shape({}),
    onlyUnique: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    maxTags: PropTypes.number,
    validationRegex: PropTypes.instanceOf(RegExp),
    disabled: PropTypes.bool,
    tagDisplayProp: PropTypes.string,
    doSetTagEditIndex: PropTypes.func,
    resetAll: PropTypes.func,
    onValidationReject: PropTypes.func,
    preventSubmit: PropTypes.bool,
    getDataForSuggestionDropdowns: PropTypes.func,
  };

  static defaultProps = {
    className: 'react-tagsinput',
    addKeys: [9, 13],
    addOnBlur: false,
    addOnPaste: false,
    inputProps: {},
    removeKeys: [8],
    renderInput: defaultRenderInput,
    renderTag: defaultRenderTag,
    renderLayout: defaultRenderLayout,
    pasteSplit: defaultPasteSplit,
    tagProps: {
      className: 'react-tagsinput-tag',
      classNameRemove: 'react-tagsinput-remove',
    },
    onlyUnique: false,
    maxTags: -1,
    validationRegex: /.*/,
    disabled: false,
    tagDisplayProp: null,
    preventSubmit: true,
    objectsAdded: [],
  };

  constructor(props) {
    super(props);
    // this.focus = ::this.focus;
    this.focus = this.focus.bind(this);
    // this.blur = ::this.blur;
    this.blur = this.blur.bind(this);
    this.state = {
      tag: '',
      selectedEditIndex: -1,
    };
  }

  componentDidMount() {
    if (this.hasControlledInput()) {
      return;
    }

    this.setState({
      tag: this.inputValue(this.props),
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    /* istanbul ignore next */
    if (this.hasControlledInput()) {
      return;
    }

    if (!this.inputValue(nextProps)) {
      return;
    }

    this.setState({
      tag: this.inputValue(nextProps),
    });
  }

  handleEditTag = key => {
    console.warn('EDIT:', key);
    this.setState({ selectedEditIndex: key }, () => {
      if (this.input && typeof this.input.focus === 'function') {
        this.input.focus();
        this.props.doSetTagEditIndex(key);
      }
    });
  };

  doSetEditIndex = (selectedEditIndex, callbackFunc) =>
    this.setState({ selectedEditIndex }, callbackFunc);

  clearEditSelection = () => this.setState({ selectedEditIndex: -1 });

  doGetTagDisplayValue = tag => {
    const { tagDisplayProp } = this.props;

    if (tagDisplayProp) {
      return tag[tagDisplayProp];
    }

    return tag;
  };

  doMakeTag = tag => {
    const { tagDisplayProp } = this.props;

    if (tagDisplayProp) {
      return {
        [tagDisplayProp]: tag,
      };
    }

    return tag;
  };

  doRemoveTag = index => {
    if (index > -1 && index < this.props.value.length) {
      this.props.onChange(index);
    }
  };

  doClearInput = () => {
    if (this.hasControlledInput()) {
      this.props.onChangeInput('');
    } else {
      this.setState({ tag: '' });
    }
  };

  doTag = () => {
    if (this.hasControlledInput()) {
      return this.props.inputValue;
    }

    return this.state.tag;
  };

  doAddTags = ctags => {
    const {
      validationRegex,
      onValidationReject,
      onlyUnique,
      maxTags,
      value,
    } = this.props;
    let tags;
    if (onlyUnique) {
      tags = uniq(ctags);
      tags = tags.filter(tag =>
        value.every(
          currentTag =>
            this.doGetTagDisplayValue(currentTag) !==
            this.doGetTagDisplayValue(tag),
        ),
      );
    }

    const rejectedTags = tags.filter(
      tag => !validationRegex.test(this.doGetTagDisplayValue(tag)),
    );
    tags = tags.filter(tag =>
      validationRegex.test(this.doGetTagDisplayValue(tag)),
    );
    tags = tags.filter(tag => {
      const tagDisplayValue = this.doGetTagDisplayValue(tag);
      if (typeof tagDisplayValue.trim === 'function') {
        return tagDisplayValue.trim().length > 0;
      }
      return tagDisplayValue;
    });

    if (maxTags >= 0) {
      const remainingLimit = Math.max(maxTags - value.length, 0);
      tags = tags.slice(0, remainingLimit);
    }

    if (onValidationReject && rejectedTags.length > 0) {
      onValidationReject(rejectedTags);
    }

    if (tags.length > 0) {
      // const newValue = value.concat(tags);
      // const indexes = [];
      // for (let i = 0; i < tags.length; i++) {
      //   indexes.push(value.length + i);
      // }
      // onChange(newValue, tags, indexes);
      this.doClearInput();
      return true;
    }

    if (rejectedTags.length > 0) {
      return false;
    }

    this.doClearInput();
    return false;
  };

  doShouldPreventDefaultEventOnAdd = (added, empty, keyCode) => {
    if (added) {
      return true;
    }

    if (keyCode === 13) {
      return this.props.preventSubmit || (!this.props.preventSubmit && !empty);
    }

    return false;
  };

  focus = () => {
    if (this.input && typeof this.input.focus === 'function') {
      this.input.focus();
    }

    this.handleOnFocus();
  };

  blur = () => {
    this.clearEditSelection();
    if (this.input && typeof this.input.blur === 'function') {
      this.input.blur();
    }

    this.handleOnBlur();
  };

  accept = () => {
    let tag = this.doTag();

    if (tag !== '') {
      tag = this.doMakeTag(tag);
      return this.doAddTags([tag]);
    }

    return false;
  };

  addTag = tag => this.doAddTags([tag]);

  clearInput = () => this.doClearInput();

  handlePaste = e => {
    const { addOnPaste, pasteSplit } = this.props;

    if (!addOnPaste) {
      return;
    }

    e.preventDefault();

    const data = getClipboardData(e);
    const tags = pasteSplit(data).map(tag => this.doMakeTag(tag));

    this.doAddTags(tags);
  };

  handleKeyDown = e => {
    if (e.defaultPrevented) {
      return;
    }

    const { value, removeKeys, addKeys, handleAdd } = this.props;
    const tag = this.doTag();
    const empty = tag === '';
    const keyCode = e.keyCode;
    const add = addKeys.indexOf(keyCode) !== -1;
    const remove = removeKeys.indexOf(keyCode) !== -1;

    if (keyCode === 27) {
      this.clearEditSelection();
    }

    if (add) {
      e.preventDefault();
      handleAdd();
      // const added = this.accept();
      // if (this.doShouldPreventDefaultEventOnAdd(added, empty, keyCode)) {
      // }
    }

    if (
      remove &&
      value.length > 0 &&
      empty &&
      this.state.selectedEditIndex < 0
    ) {
      e.preventDefault();
      this.doRemoveTag(value.length - 1);
    }
  };

  handleClick = e => {
    if (e.target === this.div) {
      this.focus();
    }
  };

  handleChange = e => {
    const { onChangeInput } = this.props;
    const { onChange } = this.props.inputProps;
    const tag = e.target.value;

    if (onChange) {
      onChange(e);
    }

    if (this.hasControlledInput()) {
      onChangeInput(tag);
    } else {
      this.setState({ tag });
    }
  };

  handleOnFocus = e => {
    // console.warn('focus child');
    this.props.doSetTagEditIndex(this.state.selectedEditIndex);
    const { onFocus } = this.props.inputProps;

    if (onFocus) {
      onFocus(e);
    }
  };

  handleOnBlur = e => {
    const { onBlur } = this.props.inputProps;

    if (e == null) {
      return;
    }

    if (onBlur) {
      onBlur(e);
    }

    if (this.props.addOnBlur) {
      const tag = this.doMakeTag(e.target.value);
      this.doAddTags([tag]);
    }
  };

  handleOnClick = e => this.props.getDataForSuggestionDropdowns(e.target.value, undefined, true);

  handleRemove = tag => {
    this.doRemoveTag(tag);
  };

  inputProps = () => {
    const {
      ...otherInputProps
    } = this.props.inputProps;

    const props = {
      ...defaultInputProps,
      ...otherInputProps,
    };

    if (this.props.disabled) {
      props.disabled = true;
    }

    return props;
  };

  inputValue = props => props.currentValue || props.inputValue || '';

  hasControlledInput = () => {
    const { inputValue, onChangeInput } = this.props;

    return (
      typeof onChangeInput === 'function' && typeof inputValue === 'string'
    );
  };

  render() {
    const {
      value,
      onChange,
      tagProps,
      renderLayout,
      renderTag,
      renderInput,
      addKeys,
      removeKeys,
      className,
      addOnBlur,
      addOnPaste,
      inputProps,
      pasteSplit,
      objectsAdded,
      onlyUnique,
      maxTags,
      validationRegex,
      disabled,
      tagDisplayProp,
      inputValue,
      onChangeInput,
      doSetTagEditIndex,
      errorPosition,
      errorMessage,
      resetAll,
      ...other
    } = this.props;
    /* eslint-enable */

    const inputComponent = renderInput({
      ref: r => {
        this.input = r;
      },
      value: this.doTag(),
      onPaste: this.handlePaste,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleChange,
      onFocus: this.handleOnFocus,
      onBlur: this.handleOnBlur,
      onClick: this.handleOnClick,
      ...this.inputProps(),
    });

    const inputReplacementComponent = (
      <span
        className="last-edit-placeholder"
        onClick={() => this.handleEditTag(-1)}
      />
    );

    const clearAllButton = (
      <button
        className="clearButton"
        data-inputid={this.props.dataInputId}
        onMouseDown={() => {
          this.setState({ tag: '', selectedEditIndex: -1 });
          resetAll();
        }}
      >
        <img src={clearIcon} alt="clear button" title="Clear All" />
      </button>
    );

    const tagComponents = value.map((tag, index) =>
      renderTag({
        key: index,
        tag,
        objectsAdded,
        onRemove: this.handleRemove,
        disabled,
        getTagDisplayValue: this.doGetTagDisplayValue,
        handleEditTag: this.handleEditTag,
        inputComponent,
        selectedEditIndex: this.state.selectedEditIndex,
        doSetTagEditIndex,
        errorPosition,
        errorMessage,
        ...tagProps,
      }),
    );

    return (
      <div
        ref={r => {
          this.div = r;
          if (this.div && r) {
            this.div.scrollTop = this.div.scrollHeight;
          }
        }}
        onClick={this.handleClick}
        className={className}
      >
        {renderLayout(
          tagComponents,
          inputComponent,
          inputReplacementComponent,
          clearAllButton,
          this.state.selectedEditIndex,
        )}
      </div>
    );
  }
}

export default TagsInput;
